export default "__VITE_ASSET__CMbadumS__"